import type { HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { Text } from '@/shared/ui'
import { IFounder } from '@/interfaces/founders'
import style from './founder.module.scss'

interface InstitutionProps extends Omit<HTMLProps<HTMLUListElement>, 'name' | 'id'>, IFounder {}

export const Founder = (props: InstitutionProps) => {
  const { className, name, image } = props

  return (
    <li className={clsx(style.container, className)}>
      {image && (
        <div className={style.logo}>
          <Image src={image.url} alt={image.title} fill />
        </div>
      )}
      {name && (
        <Text className={style.text} color="dark" type="t2" tagName="h5">
          {name}
        </Text>
      )}
    </li>
  )
}
